import React from 'react';
import './Card.css';

const Card = ({ 
  children, 
  variant = 'default', 
  padding = 'medium',
  className = '',
  onClick,
  ...props 
}) => {
  const baseClasses = 'card';
  const variantClasses = `card-${variant}`;
  const paddingClasses = `card-padding-${padding}`;
  const clickableClasses = onClick ? 'card-clickable' : '';
  
  const classes = [baseClasses, variantClasses, paddingClasses, clickableClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={classes}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
